module.exports = __webpack_public_path__ + "static/media/c.42fc27c1.png";